import React from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './primitives';
import { LOGO } from '../media';
export const NAV = [{
  label: 'What we offer',
  href: '#basecamp'
}, {
  label: 'Founders',
  href: '#founders'
}];
const JOIN_HREF = '#join';

/* FIXED: in the Lovable build the hamburger icon was not a menu. It was an
   anchor to #connect, so the entire navigation was unreachable on a phone.
   This is a real disclosure: focus trapped, Escape closes, body scroll locked,
   and aria-expanded reflects state. */

export function SiteHeader() {
  const [open, setOpen] = React.useState(false);
  const panelRef = React.useRef<HTMLDivElement>(null);
  const toggleRef = React.useRef<HTMLButtonElement>(null);
  React.useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setOpen(false);
        toggleRef.current?.focus();
        return;
      }
      if (e.key !== 'Tab' || !panelRef.current) return;
      const focusable = panelRef.current.querySelectorAll<HTMLElement>('a[href], button:not([disabled])');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    panelRef.current?.querySelector<HTMLElement>('a[href]')?.focus();
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);
  return <header className="sticky top-0 z-50 w-full border-b border-border/60 bg-background/95 backdrop-blur-md" data-id="element-84" data-mp="180qeifjy0ol8">
      <div className="section-shell flex h-20 items-center justify-between gap-4" data-id="element-85" data-mp="151876jgmjm2v">
        <a href="#top" className="min-w-0 shrink" aria-label="Vitality Foundation home" data-id="element-86" data-mp="14z55312762hs">
          <img src={LOGO} alt="Vitality Foundation" className="h-12 w-auto max-w-full object-contain object-left sm:h-14" data-id="element-87" data-mp="101vbd97rz4o5" />
        </a>

        <nav aria-label="Primary" className="hidden shrink-0 items-center gap-7 text-[11px] font-semibold lg:flex" data-id="element-88" data-mp="19t9hw0y594qs">
          {NAV.map(item => <a key={item.href} href={item.href} className="hover:text-primary" data-id="element-89" data-mp="h3iypdhnncnt">
              {item.label}
            </a>)}
          <Button href={JOIN_HREF} data-id="element-90" data-mp="w1l1vmkrxw4j">Join basecamp</Button>
        </nav>

        <button ref={toggleRef} type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="shrink-0 rounded-md p-2 lg:hidden" data-id="element-91" data-mp="r1qgfyjrpyqv">
          {open ? <X data-id="element-92" data-mp="29zvc9zx5x371" /> : <Menu data-id="element-93" data-mp="29zv95r1v8n2t" />}
        </button>
      </div>

      {open && <div id="mobile-nav" ref={panelRef} className="border-t border-border bg-background lg:hidden" data-id="element-94" data-mp="2ez7z4ko1aa9m">
          <nav aria-label="Primary mobile" className="section-shell flex flex-col gap-1 py-6" data-id="element-95" data-mp="210rsetq68jrh">
            {NAV.map(item => <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="border-b border-border/60 py-4 font-serif text-h4" data-id="element-96" data-mp="2534loinqep7d">
                {item.label}
              </a>)}
            <div className="pt-6" data-id="element-97" data-mp="2jxsxeejq6jvf">
              <Button href={JOIN_HREF} className="w-full" onClick={() => setOpen(false)} data-id="element-98" data-mp="2nzwb79tva0jv">
                Join basecamp
              </Button>
            </div>
          </nav>
        </div>}
    </header>;
}